import './imageBackgrounds.css';

// Keep earlier values renderable so existing pages retain their backgrounds.
export const imageBackgrounds = [
  {value: 'none', label: 'No background', className: 'bg-hazumu-white'},
  {value: 'white', label: 'White', className: 'bg-hazumu-white'},
  {value: 'sand', label: 'Sand', className: 'bg-hazumu-border'},
  {value: 'terracotta', label: 'Terracotta', className: 'bg-hazumu-terracotta'},
  {value: 'gold', label: 'Gold', className: 'bg-hazumu-gold'},
  {value: 'green', label: 'Sage green', className: 'bg-hazumu-sage'},
  {value: 'forest', label: 'Forest', className: 'bg-hazumu-sage-deep'},
  {value: 'ink', label: 'Ink', className: 'bg-hazumu-ink'},
  {value: 'sunrise', label: 'Sunrise gradient', className: 'image-background-sunrise'},
  {value: 'meadow', label: 'Meadow gradient', className: 'image-background-meadow'},
  {value: 'rose', label: 'Rose gradient', className: 'image-background-rose'},
  {value: 'dusk', label: 'Dusk gradient', className: 'image-background-dusk'},
  {value: 'cream', label: 'Cream', className: 'bg-hazumu-canvas'},
  {value: 'blush', label: 'Blush', className: 'bg-hazumu-blush'},
  {value: 'sage', label: 'Pale sage', className: 'bg-hazumu-sage-pale'},
] as const;
export const backgroundSwatches = imageBackgrounds.filter(background => !['cream', 'blush', 'sage'].includes(background.value));

/** A framed picture's or video's mat: its chosen colour, else the theme's panel. */
export const mediaMat = (background: string) =>
  imageBackgrounds.find((option) => option.value === background && option.value !== "none")?.className ??
  "bg-site-panel";

